/** ตัดชื่อร้านที่ซ้ำออกจากชื่อสาขา — ใช้แสดงใน POS */
export function formatPosBranchDisplayLabel(
  branchName: string,
  shopName?: string | null,
): string {
  const raw = branchName.trim();
  if (!raw) return raw;

  const shop = shopName?.trim();
  if (!shop) return raw;

  const shopLower = shop.toLowerCase();
  const rawLower = raw.toLowerCase();

  if (rawLower === shopLower) {
    return "ສາຂາຫຼັກ";
  }

  const separators = [" - ", " – ", " — ", " · ", " / ", " | ", ": "];
  for (const sep of separators) {
    const prefix = `${shop}${sep}`;
    if (rawLower.startsWith(prefix.toLowerCase())) {
      const rest = raw.slice(prefix.length).trim();
      if (rest) return rest;
    }
  }

  if (rawLower.startsWith(shopLower)) {
    const rest = raw.slice(shop.length).replace(/^[\s\-–—·/|:]+/, "").trim();
    if (rest) return rest;
  }

  return raw;
}

export function formatPosBranchOptionLabel(
  branchName: string,
  shopName: string | null | undefined,
  isActive = true,
): string {
  const display = formatPosBranchDisplayLabel(branchName, shopName);
  return isActive ? display : `${display} · ປິດ`;
}
